import { Component, inject, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatSidebarComponent } from './sidebar/chat-sidebar.component';
import { ChatWindowComponent } from './window/chat-window.component';
import { ChatStateService } from '../../services/chat/chat-state.service';

@Component({
    selector: 'app-chat',
    standalone: true,
    imports: [CommonModule, ChatSidebarComponent, ChatWindowComponent],
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
    protected readonly state = inject(ChatStateService);
    isMobileView = false;

    ngOnInit() {
        this.checkScreenSize();
    }

    @HostListener('window:resize')
    onResize() {
        this.checkScreenSize();
    }

    private checkScreenSize() {
        this.isMobileView = window.innerWidth < 768;
    }
}
